import API from '../config/api';
import React, { useState } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';
import { Card, Form, Button, Spinner } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import { useNavigate, Link } from 'react-router-dom';

import CustomNavbar from '../components/CustomNavbar';
import AuthBackground from '../components/AuthBackground';
import { claimGuestHistory } from '../utils/productTracking';
import { authStyles, divineAuthStyles } from './ForgotPasswordPage';

function LoginPage() {
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const loginHandler = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const { data } = await axios.post(
        `${API}/users/login`,
        {
          email,
          password
        }
      );

      localStorage.setItem('userInfo', JSON.stringify(data));

      /* Attribute this browser's guest browsing to the account */
      await claimGuestHistory(data._id);

      toast.success('Login Successful');

      /* Let the background-music control announce itself after login */
      window.dispatchEvent(new Event('show-music-hint'));

      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Invalid Email or Password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <CustomNavbar />

      <div className="auth-wrap">
        <AuthBackground />

        <Card className="border-0 shadow-lg auth-card auth-card-glass auth-divine">
          {/* Sacred syllable watermark */}
          <span className="ad-om" aria-hidden="true">
            ॐ
          </span>

          {/* Lamps burning at the top corners */}
          <span className="ad-lamp ad-lamp-left" aria-hidden="true">
            <span className="ad-flame" />
            🪔
          </span>
          <span className="ad-lamp ad-lamp-right" aria-hidden="true">
            <span className="ad-flame" />
            🪔
          </span>

          <Card.Body className="p-4 p-md-5 position-relative">
            <div className="text-center mb-4">
              <div className="auth-icon">🙏</div>

              <h3 className="fw-bold mb-2 ad-title">Welcome Back</h3>

              <p className="text-muted mb-0">
                Sign in to continue your journey with PoojaMart.
              </p>
            </div>

            <Form onSubmit={loginHandler}>
              <Form.Group className="mb-3">
                <Form.Label className="fw-semibold">Email Address</Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">✉️</span>

                  <Form.Control
                    type="email"
                    placeholder="you@example.com"
                    className="auth-input"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-2">
                <Form.Label className="fw-semibold">Password</Form.Label>

                <div className="auth-input-group">
                  <span className="auth-input-icon">🔑</span>

                  <Form.Control
                    type={show ? 'text' : 'password'}
                    placeholder="Enter your password"
                    className="auth-input"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />

                  <button
                    type="button"
                    className="auth-eye"
                    onClick={() => setShow((s) => !s)}
                    aria-label={show ? 'Hide password' : 'Show password'}
                  >
                    {show ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </Form.Group>

              <div className="text-end mb-4">
                <Link to="/forgot-password" className="auth-link small">
                  Forgot Password?
                </Link>
              </div>

              <Button
                type="submit"
                className="w-100 fw-bold auth-btn"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Logging in...
                  </>
                ) : (
                  'Login'
                )}
              </Button>
            </Form>

            <div className="text-center mt-4">
              <span className="text-muted">Don't have an account? </span>
              <Link to="/signup" className="auth-link">
                Sign Up
              </Link>
            </div>

            <div className="auth-divider">
              <span>or</span>
            </div>

            <Link
              to="/delivery/login"
              className="d-flex align-items-center justify-content-center gap-2 fw-semibold auth-partner-link"
            >
              🛵 Are you a Delivery Partner? →
            </Link>
          </Card.Body>
        </Card>
      </div>

      <style>{authStyles}</style>
      <style>{divineAuthStyles}</style>
    </>
  );
}

export default LoginPage;
